import { jsx as o } from "react/jsx-runtime";
const r = ({ className: t, size: C }) => /* @__PURE__ */ o(
  "svg",
  {
    className: t,
    fill: "none",
    height: C,
    viewBox: "0 0 8 8",
    width: C,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M7.75 3H5V0.25C5 0.183696 4.97366 0.120107 4.92678 0.0732234C4.87989 0.0263393 4.8163 0 4.75 0H3.25C3.1837 0 3.12011 0.0263393 3.07322 0.0732234C3.02634 0.120107 3 0.183696 3 0.25V3H0.25C0.183696 3 0.120107 3.02634 0.0732231 3.07322C0.026339 3.12011 0 3.1837 0 3.25V4.75C0 4.8163 0.026339 4.87989 0.0732231 4.92678C0.120107 4.97366 0.183696 5 0.25 5H3V7.75C3 7.8163 3.02634 7.87989 3.07322 7.92678C3.12011 7.97366 3.1837 8 3.25 8H4.75C4.8163 8 4.87989 7.97366 4.92678 7.92678C4.97366 7.87989 5 7.8163 5 7.75V5H7.75C7.8163 5 7.87989 4.97366 7.92678 4.92678C7.97366 4.87989 8 4.8163 8 4.75V3.25C8 3.1837 7.97366 3.12011 7.92678 3.07322C7.87989 3.02634 7.8163 3 7.75 3Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  r as Plus
};
